import {RootState} from '../../rootReducer';

export const getIsSignedIn = (state: RootState) => state.auth.isSignedIn;

export const getIsSigningIn = (state: RootState) => state.auth.isSigningIn;

export const getIsSigningOut = (state: RootState) => state.auth.isSigningOut;

export const getSignInChecked = (state: RootState) => state.auth.signInChecked;

export const getAccessToken = (state: RootState) => state.auth.accessToken;
